<template lang="jade">
  .wrapper
    button.btn.btn3d.btn-success.btn-sm(style="width: 100px;", :disabled="!allValid", @click="doAutoFill",
    ref="confirm") Confirmar
    InputRowGroup(useState="autoComplete/entrada", kind="entrata", v-focus="", @doAutoFill="doAutoFill")
    InputRowGroup(useState="autoComplete/pausa", kind="pausa", @doAutoFill="doAutoFill")
    InputRowGroup(useState="autoComplete/retorno", kind="retorno", @doAutoFill="doAutoFill")
    InputRowGroup(useState="autoComplete/saida", kind="saida", @doAutoFill="doAutoFill")
    div(style="width: 120px;")
      DayJourneyComplete(:allowEdit="true")

</template>

<script>
import InputRowGroup from './InputRowGroup.vue'
import { isInputTimeValid, inputTimeToMoment } from '../../../utils'
import { mapGetters } from 'vuex'
import { handleRequest } from '../../../services'
import DayJourneyComplete from './DayJourneyComplete'

export default {
  components: {InputRowGroup, DayJourneyComplete},
  computed: {
    ...mapGetters('autoComplete', ['entrada', 'pausa', 'retorno', 'saida']),
    allValid () {
      const all = [this.entrada, this.pausa, this.retorno, this.saida]

      const valids = all.filter(i => isInputTimeValid(i.value))
      const notValids = all.filter(i => !isInputTimeValid(i.value) && i.value)

      if (this.entrada.value && this.pausa.value && this.retorno.value && this.saida.value) {
        return valids.length === 4 && notValids.length === 0
      } else if (this.entrada.value && this.saida.value) {
        return valids.length === 2 && notValids.length === 0
      } else if (this.entrada.value && this.pausa.value) {
        return valids.length === 2 && notValids.length === 0
      }
    },
    allToMoment () {
      const all = [this.entrada, this.pausa, this.retorno, this.saida]
      return all.map(i => i.value ? inputTimeToMoment(i.value) : null)
    }
  },
  methods: {
    async doAutoFill () {
      this.$store.commit('seendingSheet', true)
      const result = await handleRequest.autoFill({
        id: this.$store.getters.currentSheetId,
        digits: this.onlyNeededToUpdate(this.$store.getters.currentSheetRows),
        times: this.allToMoment.map(i => i ? i.toISOString() : null)
      })
      if (result.data && result.data.success) {
        this.$store.commit('autoFillRows', result.data.success)
      }
      this.$store.dispatch('autoCompleting', false)
      this.$store.commit('seendingSheet', false)
    },
    onlyNeededToUpdate (rows) {
      const times = [this.entrada, this.pausa, this.retorno, this.saida].map(i => i ? i.value : null)
      let toSend = []
      for (let i = 0; i < rows.length; i++) {
        toSend[i] = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null]
      }
      rows.forEach((row, r) => {
        if (this.$store.getters.selectedRowsAutoFill.includes(r)) {
          row.groups.forEach((group, g) => {
            group.forEach((digit, d) => {
              let comp = times && times[g] ? times[g][d] : 'E'

              if (digit.user_predicted && digit.user_predicted === comp) { return }
              if (!digit.user_predicted && digit.machine_predicted && digit.machine_predicted === comp) { return }
              if (!digit.user_predicted && digit.machine_predicted && digit.machine_predicted === 'E') { return }

              toSend[r][d + (g * 4)] = digit.id
            })
          })
        }
      })
      return toSend
    }
  }
}
</script>

<style scoped>
.wrapper {
  width: 100%;
  max-width: 100%;
  display: grid;
  grid-template-columns: 16% auto auto auto auto auto;
}
::selection {
  color: white;
  background: rgb(140, 140, 140);
}
</style>



// WEBPACK FOOTER //
// AutoComplete.vue?4aa2386a